import { createReducer } from '../../utilities';

import {
    GET_ALERT_MPG, GET_ALERT_MPG_SUCCESS, GET_ALERT_MPG_ERROR,
    REQUEST_UPDATE_ALERT, SUCCESS_UPDATE_ALERT, FAIL_UPDATE_ALERT,
} from '../../../actions/entities/alertMPG'

const scope = "MODIFY_ALERT";

const initialModifyAlertMPG = {
    id: null,
    info: {
        isFetching: false,
        lastAction: null,
        needRefresh: false,
        lastResponse: null,
        updatedAt: null,
        success: null,
        error: null,
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { lastResponse, receivedAt, id } = action;
    return {
        id: id,
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            lastResponse: lastResponse,
            updatedAt: receivedAt,
            success: true,
            error: false
        }
    }
}

function fail(state, action) {
    const { error } = action;
    return {
        ...state,
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            success: false,
            error
        }
    };
}

export default createReducer(initialModifyAlertMPG, {
    [GET_ALERT_MPG]: request,
    [GET_ALERT_MPG_SUCCESS]: success,
    [GET_ALERT_MPG_ERROR]: fail,

    [REQUEST_UPDATE_ALERT]: request,
    [SUCCESS_UPDATE_ALERT]: success,
    [FAIL_UPDATE_ALERT]: fail,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/alertMPG/modify.js